import TomSelect from "../../js/tom-select/tom-select.0c9bda91e62b.js";
import { OpenInsuranceSelectorEventType } from "../../js/insurance-selector-events.541824bb3263.js";
import CustomAmplitudeClient from "../../js/custom-amplitude-client.8d2468912b6f.js";
import { createOptionRenderer } from "./pet-tomselect-utils.b93c6b1d8b56.js";
import { MOBILE_SCREEN_QUERY } from "../../js/shared.3c04262e7f5d.js";
import { addTomSelectAriaLabel } from "../../js/fancy-dropdowns.3e2d7c0fd3ef.js";
import { FloatingLabel } from "../../js/floating-label.895f0e243516.js";

export const PET_INSURANCE_SELECTOR_ID = "pet-insurance";
class PetInsuranceSelector extends HTMLElement {
  constructor() {
    super();
    this.displayDisabled = this.hasAttribute("data-display-disabled");
    this.insuranceSelector = null;
    this.dropdown = null;
  }

  connectedCallback() {
    const pageConfig = JSON.parse(
      document.getElementById("page-config").textContent,
    );
    this.amplitudeClient = new CustomAmplitudeClient(pageConfig.analyticsUrl);
    this.config = pageConfig;

    const networkConfigs = JSON.parse(
      document.getElementById("pet-network-configs").textContent,
    );
    this.insuranceSelector = this.querySelector(
      `#${PET_INSURANCE_SELECTOR_ID}`,
    );

    // The initial value for the selector is empty array if nothing is selected.
    // If cash is selected it will be SPECIFIED_NO_INSURANCE_VALUE ("specified-no-plan") in a 1-item array.
    const selectedItems = [];
    const selectedNetworkConfigJsonElement = document.getElementById(
      "current-network-config",
    );
    if (selectedNetworkConfigJsonElement) {
      const selectedNetworkConfig = JSON.parse(
        selectedNetworkConfigJsonElement.textContent,
      );
      selectedItems.push(selectedNetworkConfig.value);
    }

    this.dropdown = new TomSelect(this.insuranceSelector, {
      dropdownParent: this.insuranceSelector.parentElement,
      options: networkConfigs,
      valueField: "value",
      labelField: "label",
      searchField: "label",
      items: selectedItems,
      onDropdownClose: () => {
        if (document.activeElement === this.dropdown.control_input) {
          this.advance();
        }
      },
      render: {
        option: createOptionRenderer(this.displayDisabled),
      },
    });

    addTomSelectAriaLabel(this.insuranceSelector, this.dropdown);

    FloatingLabel.withTomSelect(this, this.dropdown);

    this.dropdown.on("change", this.handleDropdownChange);
    this.insuranceSelector.addEventListener("change", this.handleNativeChange);

    this.updateRequiredState();

    document.addEventListener(
      OpenInsuranceSelectorEventType,
      this.handleOpenEvent,
    );
  }

  handleDropdownChange = () => {
    this.updateRequiredState();
    this.advance();

    // Dispatch event for browse page to listen to
    const selectedNetworkConfig =
      this.dropdown.options[this.dropdown.getValue()];
    if (selectedNetworkConfig) {
      document.dispatchEvent(
        new CustomEvent("tqc:pet-insurance-changed", {
          detail: { networkConfig: selectedNetworkConfig },
          bubbles: true,
        }),
      );
      this.amplitudeClient.trackEvent("insurance_plan_selected", {
        network_config_id: selectedNetworkConfig.value,
        network_name: selectedNetworkConfig.label ?? "",
        coverage_type: "",
        product_flow: this.config.productFlow,
        search_stage: this.config.searchStage,
      });
    }
  };

  handleNativeChange = () => {
    this.updateRequiredState();
  };

  updateRequiredState = () => {
    // Drop the `required` attribute when any option is chosen (including cash),
    // and add it back when no choice exists. This allows the form to submit.
    if (!this.insuranceSelector || !this.dropdown) {
      return;
    }
    const hasSelection = this.dropdown.items.length > 0;
    this.insuranceSelector.required = !hasSelection;
  };

  advance = () => {
    // mobile and desktop have different submit buttons
    const submitButtons = document.querySelectorAll(
      "#rates-form button[type='submit']",
    );
    const visibleButton = Array.from(submitButtons).find(
      (btn) => btn.offsetParent !== null,
    );
    if (MOBILE_SCREEN_QUERY.matches) {
      document.activeElement?.blur();
    } else if (visibleButton) {
      visibleButton.focus();
    } else {
      this.dropdown.blur();
    }
  };

  disconnectedCallback() {
    document.removeEventListener(
      OpenInsuranceSelectorEventType,
      this.handleOpenEvent,
    );
    if (this.dropdown) {
      this.dropdown.off("change", this.handleDropdownChange);
    }
    if (this.insuranceSelector) {
      this.insuranceSelector.removeEventListener(
        "change",
        this.handleNativeChange,
      );
    }
  }

  handleOpenEvent = (e) => {
    if (e.scroll && window.scrollY > 0) {
      this.scrollIntoView();
    }
    this.dropdown.open();
  };
}

customElements.define("pet-insurance-selector", PetInsuranceSelector);
